import { PaymentVendor } from './PaymentVendor';

export const USD_ONLY_PAYMENT_VENDORS = [
  PaymentVendor.Affirm,
  PaymentVendor.AfterPay,
  PaymentVendor.AliPay,
];
